import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Sparkles } from "lucide-react";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: res.data } });
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-obsidian flex flex-col items-center justify-center text-center px-6">
      <div className="w-14 h-14 rounded-full border border-amber-400/40 flex items-center justify-center gold-glow animate-pulse">
        <Sparkles className="text-champagne" size={22} />
      </div>
      <p className="mt-6 font-serif text-2xl text-champagne">Preparing your concierge…</p>
      <p className="mt-2 text-slate-400 text-sm">One moment while we curate your experience.</p>
    </div>
  );
};
